import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-2c68e114")

_pushScopeId("data-v-2c68e114")
const _hoisted_1 = { class: "p-grid p-m-0 p-fluid" }
const _hoisted_2 = { class: "p-col-12" }
const _hoisted_3 = { ref: "profile-attributes-form" }
const _hoisted_4 = { class: "p-field" }
const _hoisted_5 = { class: "p-inputgroup" }
const _hoisted_6 = { class: "p-float-label" }
const _hoisted_7 = { for: "attributeName" }
const _hoisted_8 = { class: "p-field" }
const _hoisted_9 = { class: "p-inputgroup" }
const _hoisted_10 = { class: "p-float-label" }
const _hoisted_11 = { for: "attributeDescription" }
const _hoisted_12 = { class: "p-field" }
const _hoisted_13 = { class: "p-inputgroup" }
const _hoisted_14 = { class: "p-float-label" }
const _hoisted_15 = { for: "dataType" }
const _hoisted_16 = { class: "p-inputgroup p-col-6 p-sm-12 p-md-6" }
const _hoisted_17 = { class: "p-field-radiobutton p-col-6 p-sm-12 p-md-6" }
const _hoisted_18 = { for: "disableLov" }
const _hoisted_19 = { class: "p-field-radiobutton p-col-6 p-sm-12 p-md-6" }
const _hoisted_20 = { for: "enableLov" }
const _hoisted_21 = { class: "p-inputgroup" }
const _hoisted_22 = { class: "p-float-label" }
const _hoisted_23 = { for: "attributeDescription" }
const _hoisted_24 = { class: "p-inputgroup p-col-6 p-sm-12 p-md-6" }
const _hoisted_25 = { class: "p-field-radiobutton p-col-6 p-sm-12 p-md-6" }
const _hoisted_26 = /*#__PURE__*/_createVNode("i", { class: "p-ml-2 pi pi-bars" }, null, -1)
const _hoisted_27 = { for: "multiValue" }
const _hoisted_28 = { class: "p-field-radiobutton p-col-6 p-sm-12 p-md-6" }
const _hoisted_29 = /*#__PURE__*/_createVNode("i", { class: "p-ml-2 pi pi-eye" }, null, -1)
const _hoisted_30 = { for: "multiValue" }
const _hoisted_31 = { class: "p-grid p-ai-start vertical-container" }
const _hoisted_32 = { class: "p-col" }
const _hoisted_33 = {
  class: "p-m-2",
  for: "simple"
}
const _hoisted_34 = {
  key: 0,
  class: "p-mt-2"
}
const _hoisted_35 = { class: "p-col" }
const _hoisted_36 = {
  class: "p-m-2",
  for: "complex"
}
const _hoisted_37 = {
  key: 0,
  class: "p-m-2"
}
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_Button = _resolveComponent("Button")
  const _component_Toolbar = _resolveComponent("Toolbar")
  const _component_ProgressBar = _resolveComponent("ProgressBar")
  const _component_InputText = _resolveComponent("InputText")
  const _component_KnValidationMessages = _resolveComponent("KnValidationMessages")
  const _component_Dropdown = _resolveComponent("Dropdown")
  const _component_RadioButton = _resolveComponent("RadioButton")
  const _component_InputSwitch = _resolveComponent("InputSwitch")
  const _component_Card = _resolveComponent("Card")

  return (_openBlock(), _createBlock(_Fragment, null, [
    _createVNode(_component_Toolbar, { class: "kn-toolbar kn-toolbar--secondary" }, {
      start: _withId(() => [
        _createTextVNode(_toDisplayString(_ctx.attribute.attributeName), 1)
      ]),
      end: _withId(() => [
        _createVNode(_component_Button, {
          icon: "pi pi-save",
          class: "p-button-text p-button-rounded p-button-plain",
          onClick: _ctx.save,
          disabled: _ctx.formValid
        }, null, 8, ["onClick", "disabled"]),
        _createVNode(_component_Button, {
          class: "p-button-text p-button-rounded p-button-plain",
          icon: "pi pi-times",
          onClick: _ctx.closeForm
        }, null, 8, ["onClick"])
      ]),
      _: 1
    }),
    (_ctx.loading)
      ? (_openBlock(), _createBlock(_component_ProgressBar, {
          key: 0,
          mode: "indeterminate",
          class: "kn-progress-bar",
          "data-test": "progress-bar"
        }))
      : _createCommentVNode("", true),
    _createVNode("div", _hoisted_1, [
      _createVNode("div", _hoisted_2, [
        _createVNode(_component_Card, null, {
          content: _withId(() => [
            _createVNode("form", _hoisted_3, [
              _createVNode("div", _hoisted_4, [
                _createVNode("div", _hoisted_5, [
                  _createVNode("span", _hoisted_6, [
                    _createVNode(_component_InputText, {
                      id: "attributeName",
                      maxLength: "100",
                      type: "text",
                      modelValue: _ctx.v$.attribute.attributeName.$model,
                      "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_ctx.v$.attribute.attributeName.$model = $event)),
                      modelModifiers: { trim: true },
                      onChange: _cache[2] || (_cache[2] = ($event: any) => (_ctx.onDataChange(_ctx.v$.attribute.attributeName))),
                      class: "p-inputtext p-component kn-material-input"
                    }, null, 8, ["modelValue"]),
                    _createVNode("label", _hoisted_7, _toDisplayString(_ctx.$t('managers.profileAttributesManagement.form.name')) + " *", 1)
                  ])
                ]),
                _createVNode(_component_KnValidationMessages, {
                  vComp: _ctx.v$.attribute.attributeName,
                  additionalTranslateParams: { fieldName: _ctx.$t('managers.profileAttributesManagement.form.name') }
                }, null, 8, ["vComp", "additionalTranslateParams"])
              ]),
              _createVNode("div", _hoisted_8, [
                _createVNode("div", _hoisted_9, [
                  _createVNode("span", _hoisted_10, [
                    _createVNode(_component_InputText, {
                      id: "attributeDescription",
                      maxLength: "250",
                      type: "text",
                      modelValue: _ctx.v$.attribute.attributeDescription.$model,
                      "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => (_ctx.v$.attribute.attributeDescription.$model = $event)),
                      modelModifiers: { trim: true },
                      onBlur: _cache[4] || (_cache[4] = ($event: any) => (_ctx.onDataChange(_ctx.v$.attribute.attributeDescription))),
                      class: "p-inputtext p-component kn-material-input"
                    }, null, 8, ["modelValue"]),
                    _createVNode("label", _hoisted_11, _toDisplayString(_ctx.$t('managers.profileAttributesManagement.form.description')) + " *", 1)
                  ])
                ]),
                _createVNode(_component_KnValidationMessages, {
                  vComp: _ctx.v$.attribute.attributeDescription,
                  additionalTranslateParams: { fieldName: _ctx.$t('managers.profileAttributesManagement.form.description') }
                }, null, 8, ["vComp", "additionalTranslateParams"])
              ]),
              _createVNode("div", _hoisted_12, [
                _createVNode("div", _hoisted_13, [
                  _createVNode("span", _hoisted_14, [
                    _createVNode(_component_Dropdown, {
                      id: "dataType",
                      modelValue: _ctx.v$.attribute.value.$model,
                      "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => (_ctx.v$.attribute.value.$model = $event)),
                      onBeforeShow: _cache[6] || (_cache[6] = ($event: any) => (_ctx.setDirty(_ctx.v$.attribute.value))),
                      options: _ctx.attributeTypeValues,
                      optionLabel: "name",
                      optionValue: "value",
                      class: "p-dropdown p-component p-inputwrapper p-inputwrapper-filled kn-material-input",
                      onChange: _cache[7] || (_cache[7] = ($event: any) => (_ctx.onDataChange(_ctx.v$.attribute.value)))
                    }, null, 8, ["modelValue", "options"]),
                    _createVNode("label", _hoisted_15, _toDisplayString(_ctx.$t('managers.profileAttributesManagement.form.dataType')) + " *", 1)
                  ])
                ]),
                _createVNode(_component_KnValidationMessages, {
                  vComp: _ctx.v$.attribute.value,
                  additionalTranslateParams: { fieldName: _ctx.$t('managers.profileAttributesManagement.form.dataType') }
                }, null, 8, ["vComp", "additionalTranslateParams"])
              ]),
              _createVNode("div", _hoisted_16, [
                _createVNode("div", _hoisted_17, [
                  _createVNode(_component_RadioButton, {
                    id: "disableLov",
                    name: "disableLov",
                    modelValue: _ctx.disableLov,
                    "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => (_ctx.disableLov = $event)),
                    value: false,
                    onChange: _ctx.hideLovDropdown
                  }, null, 8, ["modelValue", "onChange"]),
                  _createVNode("label", _hoisted_18, _toDisplayString(_ctx.$t('managers.profileAttributesManagement.form.manualInput')), 1)
                ]),
                _createVNode("div", _hoisted_19, [
                  _createVNode(_component_RadioButton, {
                    id: "lov",
                    name: "enableLov",
                    value: false,
                    modelValue: _ctx.enableLov,
                    "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => (_ctx.enableLov = $event)),
                    onChange: _ctx.showLovDropdown
                  }, null, 8, ["modelValue", "onChange"]),
                  _createVNode("label", _hoisted_20, _toDisplayString(_ctx.$t('managers.profileAttributesManagement.form.lov')), 1)
                ])
              ]),
              _createVNode("div", {
                class: "p-field",
                hidden: _ctx.LovSelectHidden
              }, [
                _createVNode("div", _hoisted_21, [
                  _createVNode("span", _hoisted_22, [
                    _createVNode(_component_Dropdown, {
                      modelValue: _ctx.v$.attribute.lovId.$model,
                      "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => (_ctx.v$.attribute.lovId.$model = $event)),
                      options: _ctx.lovs,
                      optionLabel: "name",
                      optionValue: "id",
                      onChange: _ctx.onLoveDropdownChange,
                      onBeforeShow: _cache[11] || (_cache[11] = ($event: any) => (_ctx.setDirty(_ctx.v$.attribute.lovId))),
                      filter: true,
                      placeholder: _ctx.$t('managers.profileAttributesManagement.form.lovPlaceholder'),
                      showClear: true,
                      class: "p-dropdown p-component p-inputwrapper p-inputwrapper-filled kn-material-input"
                    }, null, 8, ["modelValue", "options", "onChange", "placeholder"]),
                    _createVNode("label", _hoisted_23, _toDisplayString(_ctx.$t('managers.profileAttributesManagement.form.lov')) + " *", 1)
                  ])
                ]),
                _createVNode(_component_KnValidationMessages, {
                  vComp: _ctx.v$.attribute.lovId,
                  additionalTranslateParams: { fieldName: _ctx.$t('managers.profileAttributesManagement.form.lov') }
                }, null, 8, ["vComp", "additionalTranslateParams"])
              ], 8, ["hidden"]),
              _createVNode("div", _hoisted_24, [
                _createVNode("div", _hoisted_25, [
                  _createVNode(_component_InputSwitch, {
                    modelValue: _ctx.v$.attribute.multivalue.$model,
                    "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => (_ctx.v$.attribute.multivalue.$model = $event)),
                    onInput: _ctx.checkSyntax(),
                    onChange: _cache[13] || (_cache[13] = ($event: any) => (_ctx.onDataChange(_ctx.v$.attribute.multivalue)))
                  }, null, 8, ["modelValue", "onInput"]),
                  _hoisted_26,
                  _createVNode("label", _hoisted_27, _toDisplayString(_ctx.$t('managers.profileAttributesManagement.form.multiValue')), 1)
                ]),
                _createVNode("div", _hoisted_28, [
                  _createVNode(_component_InputSwitch, {
                    modelValue: _ctx.v$.attribute.allowUser.$model,
                    "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event: any) => (_ctx.v$.attribute.allowUser.$model = $event)),
                    onChange: _cache[15] || (_cache[15] = ($event: any) => (_ctx.onDataChange(_ctx.v$.attribute.allowUser)))
                  }, null, 8, ["modelValue"]),
                  _hoisted_29,
                  _createVNode("label", _hoisted_30, _toDisplayString(_ctx.$t('managers.profileAttributesManagement.form.allowUser')), 1)
                ])
              ]),
              _createVNode("div", {
                class: "p-col-6 p-sm-12 p-md-6",
                hidden: _ctx.syntaxSelectHidden
              }, [
                _createVNode("div", _hoisted_31, [
                  _createVNode("div", _hoisted_32, [
                    _createVNode(_component_RadioButton, {
                      id: "simple",
                      name: "syntax",
                      value: false,
                      modelValue: _ctx.v$.attribute.syntax.$model,
                      "onUpdate:modelValue": _cache[16] || (_cache[16] = ($event: any) => (_ctx.v$.attribute.syntax.$model = $event)),
                      onChange: _cache[17] || (_cache[17] = ($event: any) => (_ctx.onDataChange(_ctx.v$.attribute.syntax)))
                    }, null, 8, ["modelValue"]),
                    _createVNode("label", _hoisted_33, _toDisplayString(_ctx.$t('managers.profileAttributesManagement.form.syntax.simple')), 1),
                    (_ctx.v$.attribute.syntax.$model === false)
                      ? (_openBlock(), _createBlock("div", _hoisted_34, " * Simple = ('Italy','USA','Serbia', ...) "))
                      : _createCommentVNode("", true)
                  ]),
                  _createVNode("div", _hoisted_35, [
                    _createVNode(_component_RadioButton, {
                      id: "complex",
                      name: "syntax",
                      value: true,
                      modelValue: _ctx.v$.attribute.syntax.$model,
                      "onUpdate:modelValue": _cache[18] || (_cache[18] = ($event: any) => (_ctx.v$.attribute.syntax.$model = $event)),
                      onChange: _cache[19] || (_cache[19] = ($event: any) => (_ctx.onDataChange(_ctx.v$.attribute.syntax)))
                    }, null, 8, ["modelValue"]),
                    _createVNode("label", _hoisted_36, _toDisplayString(_ctx.$t('managers.profileAttributesManagement.form.syntax.complex')), 1),
                    (_ctx.v$.attribute.syntax.$model === true)
                      ? (_openBlock(), _createBlock("div", _hoisted_37, " * Complex = {;{Italy;USA;Serbia; ...}} "))
                      : _createCommentVNode("", true)
                  ])
                ])
              ], 8, ["hidden"])
            ], 512)
          ]),
          _: 1
        })
      ])
    ])
  ], 64))
})